export const PING_INTERVAL_MS = 1000;
export const ONLINE_THRESHOLD_MS = 2000;
export const OFFLINE_THRESHOLD_MS = 10000;
export const HEALTH_CHECK_INTERVAL_MS = 500;
export const HeartbeatMessageTypes = {
    Ping: 'ping',
    Pong: 'pong',
};
/** True when UI and uploads may operate; only offline blocks them. */
export const isTransportOnline = (health) => health !== 'offline';
export const deriveConnectionHealth = ({ socketOpen, connectionReady, lastServerActivityMs, firstOpenMs, now = Date.now(), }) => {
    if (!connectionReady) {
        return 'connecting';
    }
    if (!socketOpen) {
        return 'offline';
    }
    if (lastServerActivityMs === 0) {
        const sinceOpen = now - firstOpenMs;
        if (sinceOpen <= ONLINE_THRESHOLD_MS) {
            return 'connecting';
        }
        if (sinceOpen <= OFFLINE_THRESHOLD_MS) {
            return 'networkIssue';
        }
        return 'offline';
    }
    const idle = now - lastServerActivityMs;
    if (idle <= ONLINE_THRESHOLD_MS) {
        return 'online';
    }
    if (idle <= OFFLINE_THRESHOLD_MS) {
        return 'networkIssue';
    }
    return 'offline';
};
export const shouldForceReconnect = (health) => health === 'offline';
